module.exports = __webpack_public_path__ + "static/feature-documents-1df0d027a779edd1c584a0acb1ebfb9f.png";